module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h2', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("1:1-9 GOD COMMISSIONS JOSHUA")])]), _c('div', {
    staticClass: "chapeau"
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("After the death of Moses the servant of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" said to Joshua the son of Nun, Moses’ assistant, "), _c('sup', [_vm._v("2")]), _vm._v("“Moses my servant is dead. Now therefore arise, go over this Jordan, you and all this people, into the land that I am giving to them, to the people of Israel. "), _c('sup', [_vm._v("3")]), _vm._v("Every place that the sole of your foot will tread upon I have given to you, just as I promised to Moses. "), _c('sup', [_vm._v("4")]), _vm._v("From the wilderness and this Lebanon as far as the great river, the river Euphrates, all the land of the Hittites to the Great Sea toward the going down of the sun shall be your territory. "), _c('sup', [_vm._v("5")]), _vm._v("No man shall be able to stand before you all the days of your life. Just as I was with Moses, so I will be with you. I will not leave you or forsake you. "), _c('sup', [_vm._v("6")]), _vm._v("Be strong and courageous, for you shall cause this people to inherit the land that I swore to their fathers to give them. "), _c('sup', [_vm._v("7")]), _vm._v("Only be strong and very courageous, being careful to do according to all the law that Moses my servant commanded you. Do not turn from it to the right hand or to the left, that you may have good success"), _c('a', {
    staticClass: "apnb",
    attrs: {
      "epub:type": "noteref",
      "href": "#/p1chap2#ntb-001",
      "id": "ap_ntb-001-1"
    }
  }, [_vm._v("a")]), _vm._v(" wherever you go. "), _c('sup', [_vm._v("8")]), _vm._v("This Book of the Law shall not depart from your mouth, but you shall meditate on it day and night, so that you may be careful to do according to all that is written in it. For then you will make your way prosperous, and then you will have good success. "), _c('sup', [_vm._v("9")]), _vm._v("Have I not commanded you? Be strong and courageous. Do not be frightened, and do not be dismayed, for the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" your God is with you wherever you go.”")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW:")])]), _vm._v(" The commissioning of Joshua as the successor to Moses for the leadership of Israel opens the book of Joshua. The reformers note that this call had been anticipated already, though now it becomes a reality, and is regarded as a sign of God’s continuing faithfulness. They observe that Joshua fills the office of Moses, but he also becomes a type of Christ, who will one day lead all his people into the Promised Land of eternal salvation. Joshua completes what Moses began, just as the gospel fulfills the law. The Lord promises possession of the land, which is seen as a type of heaven, provided that Joshua and the people remain in faithful obedience, and he promises victory to Joshua as he gave victory to Moses. At the outset of taking possession of the Promised Land (which the reformers regard as the Lord’s to dispose), the Lord stresses the need to keep the law and for Joshua to be constant in studying it. Our commentators are quick to note that the law (and more broadly, the Word) is the guide for all of life, to which nothing is to be added. In all that will come, the Lord promises he will be present, and therefore Joshua should take courage.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-017"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('b', [_vm._v("1:1-2 "), _c('i', [_vm._v("The Lord’s Call to Joshua")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPOINTMENT")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S A")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGN OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTINUED")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITHFULNESS")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" Here, first, we see the steadfastness of God in watching over his people, and providing for their safety. The sanction given to Joshua’s appointment, as new leader by a renewed commission, was intended to indicate the continuance of his favor, and prevent the people from thinking themselves forsaken in consequence of the death of Moses. . . . The call thus formally given was not so much on his own account, as it was to inspire the people with full confidence in following a leader whom they saw as advancing step by step in the path divinely marked out for him. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:1")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-072",
      "id": "ap_ntf-072-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REPARATION")]), _vm._v(", J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSES’")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INISTER")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON:")]), _vm._v(" The beginning of the book shows how Joshua received a command from God to lead the Israelites over Jordan into the land of Canaan. The Lord had before made known that Joshua should succeed Moses in the government of Israel, and with the laying of Moses’ hands on him he received an extraordinary measure of the gifts of God’s Spirit to enable him for the government. And therefore doubtless immediately after the death of Moses, Joshua took upon himself the supreme magistracy. But now we are told here how either as soon as Moses was dead, or after the thirty days were spent in lamenting the death of Moses . . . [the Lord] gave him the charge that is here related. Whether God spoke this to Joshua by an audible voice, by the secret working of his spirit, in some dream or vision, or by the high priest’s inquiring for him by the Urim and Thummim, we cannot conclude, because we do not find it expressed. . . . But the title given here to Joshua, that he was Moses’ minister . . . , we may well think was deliberately added to imply one reason among others why Joshua was most fit to succeed Moses in the government: namely, because having been so many years together his minister by his continual and daily conversation with Moses, he could not but learn much thereby to prepare and fit him the better for this service. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:1")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-073",
      "id": "ap_ntf-073-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA’S")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMISSION")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEN")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTICIPATED")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORE")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYER:")]), _vm._v(" [Twice before the Lord declared that] Joshua was appointed to this office of ruling and leading the people, and to encourage him the more, the Lord speaks to him again . . . that the people might the more readily obey him, and that he might the more diligently go about this his office. In that he the minister of Moses is thus preferred, Ferus"), _c('sup', [_vm._v("† ")]), _vm._v("notes mystically that only such as subject themselves to the law of God are fit to rule: and therefore Jesus himself first served and washed his disciples’ feet. And herein Joshua is a type of Christ, who was the minister of Moses when he was made subject to the law, for the law is called Moses. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:1")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-074",
      "id": "ap_ntf-074-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMISSION")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDIRECTLY FROM THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" [The Lord spoke] not immediately by himself, as he spoke to Moses as it were face to face (for this was his peculiar privilege), but either by some created voice, or by an angel, or by a vision (Joshua being awake), or by a dream in his sleep. . . . All of these were means that always made such a deep impression that the things revealed were of such infallible truth that there could be no scruple or doubt of them. Or it could be that [the Lord spoke] by the priests inquiring for him by means of Urim and Thummim, which is most probable, seeing this manner of revealing God’s will to Joshua is plainly foretold. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:1")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-075",
      "id": "ap_ntf-075-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S A")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPE OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESUS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHANNES")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RENZ:")]), _vm._v(" Joshua is shown to be a type of Christ, both in name and in deeds. For as Joshua led the Israelites across the Jordan into a land flowing with milk and honey, so Jesus Christ leads believers into an eternal happiness. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA (")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE)")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-076",
      "id": "ap_ntf-076-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA A")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPE OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESUS")]), _vm._v(", C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANAAN A")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPE OF")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAVEN")]), _vm._v(".")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMONS:")]), _vm._v(" We should reasonably not be afraid of death, which is but a rest from sin and the entrance into a better life, nor be sorrowing about the friends who have fallen asleep in God, as those do who do not expect the reward of the saints; but we should joyfully raise our heads, gird our loins with truth, and be joyfully taken up to the heavenly Canaan thus, with our only and eternal Joshua, Christ Jesus, to take the promised inheritance, and thus be freed from the laborious, troublesome way of our hard pilgrimage, which we "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("must lead through the rough desert of this wild world so long as we shall be here; and then we shall rest in eternal peace. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTERS")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-077",
      "id": "ap_ntf-077-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESUS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADS")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S TO THE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMISED")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(".")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRK")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILIPS:")]), _vm._v(" Here it is seen that both Moses and Aaron died in the wilderness. They did not enter into the Promised Land because they provoked the Lord. Joshua led the people and divided up the land. That shows us that both the law and the Levitical priesthood and its ceremonies ended and were fulfilled in Christ Jesus. These could neither bring anyone to perfection nor take away sins, nor bring justice nor blessings. But the spiritual Joshua, Jesus Christ, the prince of our faith and finisher of our salvation, leads us into the true Promised Land, the kingdom of God. This kingdom is already here in the Spirit, in the power of the new birth and abundance of spiritual gifts. And it is present in the hereafter in eternal, heavenly majesty and possession of all eternal things. For we shall be like Christ and see him face-to-face in this coming and perfect nature. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCERNING")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRITUAL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTITUTION [1559]")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-078",
      "id": "ap_ntf-078-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S TO")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL THE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFICE OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSES")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" A twofold meaning may be extracted—the one, “since Moses is dead, the whole burden has now devolved on you [Joshua], take the place of him to whom you have been appointed successor”; the other, “although Moses is dead, do not desist, but go forward.” I prefer the former, as containing the inference that he should, by right of succession, take up the office that Moses has left vacant. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:2")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-079",
      "id": "ap_ntf-079-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS IN AN")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TTITUDE OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYER")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYER:")]), _vm._v(" Mystically by Moses we understand the law of Moses, which is as a husband dead under the gospel, and now Jesus comes in his place. Some think that Joshua was now humbled in prayer, and so God bids him [to arise], which is not improbable; but by this speech he quickens him to a diligent care in executing the weighty office to which he called him. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:2")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-080",
      "id": "ap_ntf-080-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ID")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRUST")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMSELF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORWARD")]), _vm._v(".")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANCELOT")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDLEY:")]), _vm._v(" Here we may note . . . first, that Joshua the servant of Moses did not take upon himself the rule or guidance of the children of Israel on his own, nor yet that he thrust himself in this common office as if he desired it . . . but that he was called of God to it, as here in this chapter it does appear, by which action the Lord teaches that no man ought to desire or thrust himself into any common office except he be called to it . . . inwardly of God only, and be certified of that calling by some outward sign or token as the prophets of God were. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:2")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-081",
      "id": "ap_ntf-081-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFERENCE TO")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSES")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS TO")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCOURAGE")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON:")]), _vm._v(" Now in mentioning the death of Moses, the Lord uses this expression, “Moses my servant is dead.” He does this first, and principally, to imply what it was he required of Joshua, namely, that as their captain and supreme governor he should now conduct them into the land of Canaan, for Moses is here called God’s servant, in regard of the supreme magistracy to which God had advanced him, and so the drift of the words is that since Moses their governor was dead, he should now as his successor go before the people in his stead. Second, he does this to imply that as Moses in his magistracy was subordinate to God’s will, and was only to do all things according to his direction, so must it be with Joshua too. Third, that by speaking thus honorably of Moses . . . Joshua might be encouraged faithfully to serve God in his place, as Moses had done, that he also might gain such favor and esteem with God as Moses had gained. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:2")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-082",
      "id": "ap_ntf-082-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROTECTOR OF")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE;")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROVIDES")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEPHERDS")]), _vm._v(".")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOCK:")]), _vm._v(" The eternal and true God, whose counsel and wisdom exists only through himself, is the protector of his people Israel, tends them like lambs and sheep, and provides them with faithful servants and herdsmen as he did in former times, still does, and will do to the day of his appearance. He will provide us with all things, especially with servants whom he will give and present to his people, as God himself said to Joshua. . . . Now Christ is our Moses (with the law of the gospel), and after his death chose his Joshua, praying over him. These [Joshuas] are all the true servants in the church of Christ and his congregation. God the Father himself chose them with his Spirit of truth, so that through them the church of Christ has been led. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER TO")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETER")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALPOT")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-083",
      "id": "ap_ntf-083-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LONE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BLE TO")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISPOSE OF THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND AT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEASURE")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" That is, in real possession, as before he gave it by promise and right. The pronoun "), _c('i', [_vm._v("I")]), _vm._v(" has its special emphasis: I, and no other, because none but God alone, without violation of justice, can take a country from the ancient inheritors and give it to another. And he may do it as the supreme Lord and owner of all, the whole earth being his, and the fullness thereof, to dispose of it as is his proper right, according to his pleasure. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:2")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-084",
      "id": "ap_ntf-084-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-018"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('b', [_vm._v("1:3-4 "), _c('i', [_vm._v("The Promise of the Land")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EATH OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSES")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHT")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAKEN THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" It may be added that the Lord does now begin for the first time to give them good hopes, by making a promise of which they had not previously heard, but recalls to their remembrance what Moses had formerly testified. He says, therefore, that the time had now come for the exhibiting and performing of that which he had promised to Moses. . . . Moses is produced as a witness whose memory was more recent, and by whose death the confidence of the people might have been shaken, had not God declared that the accomplishment of all that he had said before was at hand. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:3")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-085",
      "id": "ap_ntf-085-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMISE AND")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVENANT WITH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDITIONS")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" The covenant and promise was not absolute but conditional: namely, if they would wholly follow the Lord their God, love, fear, and serve him. And therefore when they did backslide and worship idols, God threatened to make void this covenant, and caused these [conquered] nations often to prevail against them; and because of their apostasy and sin, he never gave the whole land promised into their possession. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:3")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-086",
      "id": "ap_ntf-086-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEANSING OF THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOULD")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARRY")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDREAS")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODENSTEIN VON")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLSTADT:")]), _vm._v(" In order that the people of Israel might practice on Gentiles and become wiser, God allowed the Gentiles all the more readily to remain, so that the Israelites might learn to fight against their enemies . . . and to understand through external warfare how the spirit can overcome and subdue the flesh and how it must fend off the beasts of the field and overcome falsehood with the truth and with wholesome teachings. If idols could defend themselves, they would not be as dangerous and not as much of an ensnaring yarn for a fall as they are. Furthermore, it is wanton for a human being to give reasons for divine statutes when there is no divine foundation for them. It is sufficient to say, God wills it. There the crafter of idols may see that he put the headgear where his feet are and that he looked at Scripture through a gauntlet. That he [Luther] bases his argument on parables I could have overlooked, provided he does not violate Scripture or harm the simple. But since his speech strives openly against God’s righteous words and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("entices the ignorant to their fall and ruination, I am not willing to do so. I must state that it is against God.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When he [Luther] states that the Jews must not leave the idols of Gentiles in their land, he speaks correctly. But when he adds his own bit by saying that the Jews had to go easy and not be hasty, that they had to cast out idols gradually and in time, he makes his own addition. God says that they were not to leave idols in their land as they were to leave the Gentiles, probably because they could not kill any worm or beast and were only prepared for sin and corruption. Therefore, whenever they were able to do so and were in control, the Jews were to destroy the idols of the Gentiles and not allow them to remain. W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HETHER")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOULD")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOWLY AND")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VOID")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFENDING THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAK")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-087",
      "id": "ap_ntf-087-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVES THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S AN")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCOURAGEMENT")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" “That I have given” is added for their singular encouragement against all doubts and difficulties, seeing that the Lord, who had supreme right to what he gave, and omnipotent power to maintain his right against all opposition, has given it to them. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:3")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-088",
      "id": "ap_ntf-088-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAS, THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AIL ON")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEIR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" The people had it in their power to obtain possession of the prescribed boundaries in due time; but they declined to do so. For this they deserved to have been expelled altogether. . . . And although it had been foretold that, in just punishment, the residue of the nations whom they spared would prove pernicious to them, still they suffered no molestation, unless when they provoked the divine anger by their perfidy and almost continual defection: for as often as their affairs became prosperous, they turned aside to wantonness. Still, owing to the wonderful goodness of God, when they were oppressed by the violence of the enemy, and as it were, thrust down to the grave, . . . every now and then deliverers arose, and, contrary to all hope, retrieved them from ruin. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:4")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-089",
      "id": "ap_ntf-089-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BEDIENCE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EQUIRED, BUT")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKING")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON:")]), _vm._v(" Indeed, that the Israelites never did extend the bounds of the land thus far is evident. . . . But the reason of this was, because the people of Israel failed in keeping covenant with God, and it was only upon condition of their obedience that God promised thus far to enlarge their borders. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:4")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-090",
      "id": "ap_ntf-090-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-019"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('b', [_vm._v("1:5-6 "), _c('i', [_vm._v("The Lord’s Assurance to Joshua")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BANDON")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOSE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HO")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URN FROM")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVETOUSNESS")]), _vm._v(".")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESIDERIUS")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RASMUS:")]), _vm._v(" There should be no covetousness in your conduct. Be content then with such things as you have, living as it were from day to day without concern for the future. For it was with this intention that God himself promised Joshua and likewise all who have faith in him, “I do not forsake you or abandon you,” so that relying on this promise we may now say with confidence what the prophet says in the mystic psalm: “The Lord is my helper, I will not fear what man will do to me.” P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARAPHRASE ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EBREWS 13:5")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-091",
      "id": "ap_ntf-091-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMARKABLE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SSURANCE OF")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICTORY")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" As a contest was about to be waged with numerous and warlike enemies, it was necessary thus to inspire Joshua with special confidence. . . . For how vast the enterprise to overthrow so many nations! . . . And the better to free him from all doubt, he is reminded of the victories of Moses, by which God had made it manifest that nothing was easier for him than utterly to discomfit any host however great and powerful. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:5")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-092",
      "id": "ap_ntf-092-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_c('b', [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UCCESS")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HALL")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTINUAL")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" This is added for further encouragement, seeing that they had from God a special promise—that though their enemies far exceeded them both in number, strength, and all warlike preparations, yet God would give them the victory in the day of battle. . . . “You shall not only have some good beginnings in your undertakings, but shall have a constant and continual success.” And the Lord gives a reason here for the further confirmation of Joshua’s faith, namely, because he would ever be present with him, as he had formerly been with Moses, and give him his assistance in all his enterprises, for whom nothing is hard or difficult. . . . “As Moses prevailed in all his undertakings and was not only supported in all the difficulties of his governance of a stiff-necked, murmuring, and rebellious people, but also vanquished and subdued all those enemies on this side of the Jordan, which rose up against him . . . so shall you likewise prosper, both in your government, in which you succeed him, and also in your warlike expeditions against your enemies. . . . I will always be present with you to assist you by my power and Spirit, in all those enterprises that you undertake at my command, so that you shall easily achieve them, though they seem never so difficult; and therefore go on with courage, resting on me for good success, not only in your first beginnings; be assured that I will never fail you in the end.” A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:5")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-093",
      "id": "ap_ntf-093-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESPITE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPEARANCES")]), _vm._v(", G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LWAYS")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMAINS WITH")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERVANTS")]), _vm._v(".")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDWIG")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVATER:")]), _vm._v(" From this example he derives an argument. “Just as I was with Moses, so also I shall be with you.” The meaning is, “Even if you will have to undergo many labors, nevertheless you must not lose hope. For I will not leave you without my aid, but I shall be with you.” To be with someone indicates to support and help that person. Where God is, how can there not be there every good thing? Paul in Romans 8 proclaims, “If God is with us, who can be against us?” All God’s angels watch over those whom God takes as his own. Moses, even if he was often in the greatest danger, nevertheless successfully escaped them, and God kept him safe to the age of 120. As soon as Moses told the Israelites that he had been sent by God to lead them out of severe bondage, nothing more hopeful could have happened to them. But soon, when their toil increased, they began to accuse Moses as responsible for this hardship. And when they then had been led out of Egypt, and had witnessed astounding wonders, as they were suffering from hunger or thirst, they began to rebel against Moses and to speak angrily against him as the cause of their evils. Nevertheless, God preserved him in all these dangers and defended him. In Numbers 11, his sister Miriam and his brother Aaron did not go unpunished for striving against him. Next, in Numbers 12, that portion of the camp which had spoken against Moses was consumed by fire. The earth swallowed up Korah, Dathan, and Abiram in Numbers 16. In addition to these events, God had made Moses famous by the many and very impressive victories he gained over his enemies. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY 3 ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:5")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-094",
      "id": "ap_ntf-094-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVER")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAVE")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITHER")]), _vm._v(".")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHER:")]), _vm._v(" Although we may not have to do the same work as Joshua, whom God never forsook, nor be in exactly the same plight, yet certainly we stand in the same faith and trust. Faith may have different tasks to perform, but they are done in the same spirit. As Paul expresses it, “We share the same faith.” Therefore, though addressed to Joshua only in the first instance, the truth of this statement rightly applies to all of us. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECTURES ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EBREWS 13:5")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-095",
      "id": "ap_ntf-095-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HROUGH")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NHERIT THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" An exhortation to fortitude is added, and indeed repeated, that it may make the deeper impression. At the same time the promise is introduced in different words, in which "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("Joshua is assured of his divine call, that he might have no hesitation in undertaking the office which has been divinely committed to him, nor begin to waver midway on being obliged to contend with obstacles. . . . We may infer from this passage that bare promises are not sufficiently energetic without the additional stimulus of exhortation. For if Joshua, who was always remarkable for alacrity, required to be incited to the performance of duty, how much more necessary must it be that we who labor under so much sluggishness should be spurred forward. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:6")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-096",
      "id": "ap_ntf-096-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPLETED")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSES")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OULD")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHANN")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERHARD:")]), _vm._v(" Since Moses therefore could not accomplish this work [the conquest of the land], and while, at the same time, God the Lord wanted to see his promise to the patriarchs fulfilled, behold, the Lord thus raised up Joshua the son of Nun, Moses’ servant. He filled him with the Spirit of wisdom and said to him, “Be comforted and undismayed. . . .” This history is a prototypical portrayal of how the law (which was given through Moses . . .) is unable to bring us to the promised inheritance of eternal life (which was signified by the land of Canaan). Only Christ accomplishes this, and Joshua was a prototypical portrayal of him. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST’S")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRCUMCISION")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-097",
      "id": "ap_ntf-097-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSES")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAT, BUT")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITHOUT")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAKNESS")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYER:")]), _vm._v(" The Lord knew that the people who were now to be led by Joshua were very perverse, and the enemies to be subdued were many and mighty. Therefore, he confirms Joshua with many words, and most ample promises; and the more so because Moses, though so holy a man, yet in time of provocation by the people had shown great weakness. The Lord says that none should be able to stand before him all the days of his life; for after his death, the people sinned, and then their enemies prevailed, as is shown several times in the book of Judges. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:6")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-098",
      "id": "ap_ntf-098-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OULD")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CCOMPLISH")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSES")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ID")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" Though Joshua was exceedingly valiant, the work he is now to undertake had in it so many great difficulties that the Lord thought it not superfluous to often repeat these encouragements, seeing that as a governor he was to sustain a heavy burden in respect of the perverse disposition of the people, and to undergo many difficulties and dangers in respect of the enemies whom he was to encounter, being men of vast and giant-like stature and strength, and dwelling in cities with high walls and strongly fortified. . . . “Be courageous in this undertaking in respect of the greatness of the reward, seeing hereby you shall attain unto a higher degree of honor than I vouchsafed to Moses. For he only led Israel through the wilderness, but was not permitted to bring them into the Promised Land, whereas you shall not only subdue all these nations but also divide their land among your people, and settle them in it as their inheritance, as by oath I promised to Abraham, Isaac, and Jacob, that I would do in the fourth generation, which time is now come.” A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:6")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-099",
      "id": "ap_ntf-099-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HY THE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPEATED")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCOURAGEMENT?")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON:")]), _vm._v(" We find this [exhortation] often pressed upon Joshua: first by Moses, for which he had a special command from God; second, by the Lord himself, and so again three times in this chapter here at verse 6 and verse 7 and verse 9; and last of all by the people. And why was this? Not because Joshua had discovered in himself any faintheartedness or cowardice; but first, because the work he was to undertake was so weighty and perilous, not only in regard of those many and mighty nations whom he was to destroy and plant the Israelites in their place, but especially in regard of the stubbornness of the people whom he was to govern, of whose rebellion against Moses, yea against God, he had often been an eyewitness; second, because the Lord knew well that Joshua "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("had humble and low thoughts of himself, and much feared his insufficiency for so great a charge (as indeed the wiser and the more able men are, the more protective they are of themselves in such cases); and third, because even those who are best resolved still need to be stimulated and stirred up, and that principally, lest they should shrink from doing exactly what God has enjoined them for fear of any difficulty that may lie in their way—of which God gives Joshua special warning in the following verse. . . . It is as if he had said, I have appointed this to be your honor, and therefore be not afraid to undertake the charge. And indeed this was the principal way in which Joshua was a type of Christ: Moses did not carry the Israelites into the land of Canaan, but Moses being dead, Joshua did it; so neither could the law carry us into the heavenly Canaan, for by the righteousness of the law can no one be saved; but Christ, our Jesus, our Savior, has by his merits opened a way for us into the heavenly Canaan, and is gone before to prepare a place for us. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:6")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-100",
      "id": "ap_ntf-100-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-020"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('b', [_vm._v("1:7-9 "), _c('i', [_vm._v("Be Guided by God’s Word to You")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AW")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UST")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UIDE")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" It is added as a true source of fortitude that Joshua shall make it his constant study to observe the law. By this we are taught that the only way in which we can become truly invincible is by striving to give a faithful obedience to God. . . . Moreover, God would not only have his servant to be strong in keeping the law, but commands him to contend with all might, so as not to faint under the burden of his demanding office. But as he might become involved in doubt as to the means of disentangling himself in matters of perplexity, or as to the course which he ought to adopt, the Lord refers him to the teaching of the law, because by following it as a guide he will be suitably equipped for all things. He says, “You shall act prudently in all things, provided you make the law your master.” . . . The general prohibition, therefore, contained in the law—forbidding all people to add to it or detract from it—God now specially enforces on Joshua. For if private individuals in forming their plan of life are advised to submit themselves to God, much more necessary must this be for those who hold rule among the people. But if this great man needed this curb of modesty that he might not overstep his limits, how intolerable the audacity if we, who fall so short of him, claim for ourselves greater license? C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:7")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-101",
      "id": "ap_ntf-101-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BEDIENCE IN")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEPING THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AW")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNDAMENTAL")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYER:")]), _vm._v(" So that Joshua might not be cowardly, but courageous, he has a special charge given him to attend to the law of God, and to do it in all things with all care and diligence. And hereby obedience to God, and subjection to his law, is shown to be the ground of all true courage, such that great undertakings which are made without this being nothing but boldness and rashness; which, however one may prevail at the beginning, yet one shall never be able finally to bring anything to good effect, as Calvin notes. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:7")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-102",
      "id": "ap_ntf-102-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VANGELICAL")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BEDIENCE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S IN")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IEW")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" Here the Lord not only requires courage and resolution in Joshua but also shows him the only sure foundation upon which it was to be grounded, namely, his obedience to God’s law delivered by the ministry of his servant Moses, which he was to make the rule of his whole life, not swerving from it either on the one side or the other, in any extreme of excess of defect, through superstition or profaneness, adding to it or detracting from it: without which, though there may be in captains and commanders desperate rashness, yet among such no true fortitude or well-grounded courage. But this is not to be understood to be a perfect and exact legal obedience, to which degree no mortal can attain, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("but to be that evangelical obedience to the law which consists in fervent desires and earnest endeavors, which God in Christ accepts from us. God requires not impossibilities of those who are in Christ, but only by his strict commands admonishes us what we ought to do, and teaches us to pray for what we cannot do. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:7")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-103",
      "id": "ap_ntf-103-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TERN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARNING")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GAINST")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DDING TO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")]), _vm._v(".")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEMNITZ:")]), _vm._v(" God therefore sets forth his Word as the norm of good works, and that in such a way that he rejects self-chosen acts of worship and commandments which are taught because people imagine that they constitute worship. And he asserts that his Word is the most complete norm, for he says . . . “You shall not turn aside to the right hand or to the left.” Therefore when anything is added by human beings to the divine rule of good works, which God himself declared to be most complete, a wrong is done to it. And the norm of good works ought to be set forth in the church from the Word of God, in addition to other reasons, also for this one, that it may remind us of our imperfection in the exercise and course of good works. For in human traditions and self-chosen acts of worship the human mind can easily deceive itself with the idea of perfection, yes, of supererogation, which is destructive of the doctrine of justification. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCERNING")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-104",
      "id": "ap_ntf-104-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BEDIENCE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAD TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LESSING AND")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISDOM")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON:")]), _vm._v(" If we read the words as they stand in our Bibles, then there is here a promise implied, that if Joshua did strictly observe God’s law, not yielding in any way to turn aside from that rule, he should prosper in everything that he undertook. But if we read the last clause as it is given in the margin of our Bibles"), _c('sup', [_vm._v("†")]), _vm._v("—“that you may do wisely wherever you go”—then the drift of these words must be either to give Joshua to understand that it would be his greatest wisdom to do in all things as God in his law enjoined him, whatever his own reason might suggest to the contrary . . . , or else to assure him that if he did sincerely observe to do all things according to God’s law, then the Lord would more abundantly pour forth the spirit of wisdom upon him. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:7")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-105",
      "id": "ap_ntf-105-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TUDY OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UST")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTANT")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" Untiring meditation on the law is commanded; because whenever it is suspended, even for a short time, many errors readily creep in, and the memory becomes rusted, so that many, after ceasing from the continuous study of it, engage in practical business, and become mere ignorant beginners. God therefore enjoins his servant to make daily progress, and never cease, during the whole course of his life, to profit in the law. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:8")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-106",
      "id": "ap_ntf-106-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESPONSIBILITY TO")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACH THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" Why does God forbid him to allow the law to depart from his mouth rather than from his eyes? Some interpreters understand that the mouth is here used by synecdoche for the face. . . . He is commanded, therefore, to attend to the teaching of the law, that in accordance with the office committed to him, he may apply what he has learned for the common benefit of the people. At the same time he is ordered to make his own submissiveness a pattern of obedience to others. For many, by talking and discoursing, have the law in their mouth, but are very bad keepers of it. Both things, therefore, are commanded, that by teaching others, he may make his own conduct and whole character conform to the same rule. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:8")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-107",
      "id": "ap_ntf-107-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERNALIZE, BUT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LSO")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CT")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" It is as if the Lord says, “You shall continually take all opportunities to think and consider of the law, as being the only rule "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("to direct you in all private and public affairs . . . , not departing or declining from it at any time, or in anything, either to the right or to the left. Neither is it sufficient for you to read and know it, or to meditate and ponder on it in all its precepts and passages, unless you also observe and practice it in the whole course of your life. And so shall you carry yourself prudently and prosperously in all your undertakings, and have good success in all your counsels and enterprises.” A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:8")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-108",
      "id": "ap_ntf-108-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOSE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULED BY THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UCCESS")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" At the end of the verse, because the term used is ambiguous . . . the sentence is repeated, or a second promise is added. The latter is the view I take. For it was most suitable that, after the promised success, Joshua should be reminded that people never act skillfully and regularly except insofar as they allow themselves to be ruled by the word of God. Accordingly, the prudence that believers learn from the word of God is opposed to the confidence of those who consider their own sense sufficient to guide them aright. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:8")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-109",
      "id": "ap_ntf-109-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E AN")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPERT IN THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AW")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON:")]), _vm._v(" The book of the Law that Moses wrote was delivered to the Levites, to be laid up by them inside the ark . . . ; it was therefore a copy of this law of which the Lord here spoke to Joshua, and the meaning of this is, that by frequent and continual reading and consultation he should labor to be so expert in it that in all his judgments he should be able readily to judge as it was in the law determined, and in all other things to order himself according to the directions that were here given. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:8")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-110",
      "id": "ap_ntf-110-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMEMBER")]), _vm._v(", I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HO")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMANDS")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" Although in Hebrew a simple affirmation is often made in the form of a question, and this phraseology is of very frequent occurrence, here, however, the question is emphatic, to give an attestation to what had previously been taught, while the Lord, by bringing his own authority distinctly forward, relieves his servant from care and hesitancy. He asks, “Is it not I who have commanded you? I too will be present with you.” Observe the emphasis, inasmuch as it is not lawful to resist his command. This passage also teaches that nothing is more effectual to produce this confidence than when trusting in the call and command of God, and feeling fully assured of it in our own conscience, we follow wherever he is pleased to lead. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:9")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-111",
      "id": "ap_ntf-111-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMANDS")]), _vm._v(", W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELL")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURAGEOUS")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYER:")]), _vm._v(" When God is the author of any endeavor, people may be courageous indeed, and fear nothing, as being sure to prevail. As for the words and phrases here used, some distinguish between these two words, expounding “observe” as abstaining from the evil forbidden, and “to do” as performing things commanded. But Masius"), _c('sup', [_vm._v("†")]), _vm._v(" better understands the first word to mean that study and care which makes way to performance, and the second to mean the due execution thereof. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:9")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-112",
      "id": "ap_ntf-112-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVINE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLING, AND A")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMISE OF")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVINE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESENCE")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" Here God first confirms Joshua by a divine call, and then by a promise of his effectual presence. The former is set forth by way of interrogation, which is used by the Hebrews as a strong affirmation. . . . Do what I require with a steadfast courage, remembering who it is that commands it, namely, your God, who is all sufficient to preserve you in all dangers and difficulties, and to prosper you in all your actions that you undertake at my command. [The latter is confirmed by] a promise for his better encouragement, of God’s special presence and assistance. Neither are we to understand it of God’s presence in all places, but of a singular presence or of his special favor to assist him in all "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("his enterprises, so preserve him in all difficulties and dangers, and to protect him against all his enemies. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:9")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-113",
      "id": "ap_ntf-113-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DD OR")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WAY FROM THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYER:")]), _vm._v(" By turning to the right hand, the Hebrews understand any adding to the Word of God; and by turning to the left, any taking away from it. Serrarius"), _c('sup', [_vm._v("†")]), _vm._v(" by the first understands any going out of the way of God’s commandments for gain; by the second, any going out for fear of danger or adversity suffered. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:9")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-114",
      "id": "ap_ntf-114-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTICIPATED")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERE")]), _vm._v(".")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDWIG")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVATER:")]), _vm._v(" Because Joshua is in fact a type of Christ our Savior, the following events must also be applied to Christ. Christ was given to us by God as our commander that he might lead us through the Jordan, that is, through manifold tribulation, into the Promised Land. And so he might there divide it up for us as is recorded in Joshua 14. Christ was made a minister of Moses; that is, he placed himself under the law so that he might by that means free us from the curse of the law. No one could stand against Christ, but he conquered his enemies the scribes and Pharisees, as well as Satan himself. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY 3 ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:6-9")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-115",
      "id": "ap_ntf-115-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  })])])]), _c('section', {
    staticClass: "defnotes",
    attrs: {
      "epub:type": "footnotes"
    }
  }, [_c('aside', {
    staticClass: "ntb",
    attrs: {
      "epub:type": "footnote",
      "id": "ntb-001"
    }
  }, [_c('p', {
    staticClass: "txt_ssalinea"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap2#ap_ntb-001-1"
    }
  }, [_vm._v("a")]), _vm._v(". Or "), _c('i', [_vm._v("may act wisely")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09aa1e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap2.vue
// module id = 87
// module chunks = 0